<template>
  <div id="wrapper">
    <div class="equipmentInsurance-info">
      <div class="equipmentInsurance"></div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "equipmentInsurance",
      data() {
        return {
        }
      },
      methods: {

      },
      mounted() {

      }
    }
</script>

<style scoped>
  .equipmentInsurance-info{
    width: 100%;
    padding: 0 15%;
  }
  .equipmentInsurance{
    position: relative;
    max-height: 71.25rem;
    padding-top: 97%;
    background: url("../../../static/images/product/equipmentInsurance.png") no-repeat center / cover;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/equipmentInsurance.vue